import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsEcConstants {
    // Labels
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static WHO_IS_APPLYING_LABEL = "Who is applying";
    static DESCRIPTION_OF_PROPOSED_WORK_LABEL = "Description of proposed work";
    static DESCRIPTION_OF_PROPOSED_WORK_FORM_CONTROL_NAME = "descriptionOfProposedWork";
    static DESCRIPTION_OF_PROPOSED_WORK_NOTE = "Note: For farms and agricultural holdings, fill this description as per title deed is required";
    static PHASE_LABEL = "Phase";
    static CONVENTIONAL_PREPAID_LABEL = "Conventional prepaid";
    static ESTIMATED_CAPACITY_LABEL = "Estimated capacity of electrical installation (Amp/kVa)";
    // Controls
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static APPLICANT_TYPE_FORM_CONTROL_NAME = "applicantType";
    static PHASE_FORM_CONTROL_NAME = "phase";
    static PAYMENT_TYPE_CONTROL_NAME = "paymentType";
    static ESTIMATED_CAPACITY_FORM_CONTROL_NAME = "estimatedCapacity";
    // LookupNames
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static APPLICANT_TYPE_LOOKUP_NAME = "ApplicantType";
    static PHASE_LOOKUP_NAME = "Phase";
    static CONVENTIONAL_PREPAID_LOOKUP_NAME = "ConventionalPrepaid";
    // Validation messages
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, whoIsApplying: {
            required: `who is applying ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, descriptionOfProposedWork: {
            required: `Description of proposed work ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, phase: {
            required: `Phase ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, conventionalPrepaid: {
            required: `Conventional prepaid ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, estimatedCapacity: {
            required: `Estimated capacity ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static BuildingNameControl;
}
